module.exports = __webpack_public_path__ + "images/icono-5-costos-editado-con-visit.jpg";